module.exports = __webpack_public_path__ + "static/media/city-skyline.ba58752b.jpg";